/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function () {
  const siteNavigation = document.getElementById("site-navigation");

  /**
   * making a sticky top navigation
   */
  window.addEventListener("scroll", function () {
    let header = this.document.querySelector(".nav-container");

    if (!header) return;

    let prevElement = header.previousElementSibling;

    const theHeight = prevElement.offsetHeight;
    // const theHeight = 0;

    header.classList.toggle("fixed-menu", this.window.scrollY > theHeight);
  });

  // Return early if the navigation doesn't exist.
  if (!siteNavigation) {
    return;
  }

  const button = siteNavigation.getElementsByTagName("button")[0];

  // Return early if the button doesn't exist.
  if ("undefined" === typeof button) {
    return;
  }

  const menu = siteNavigation.getElementsByTagName("ul")[0];

  // Hide menu toggle button if menu is empty and return early.
  if ("undefined" === typeof menu) {
    button.style.display = "none";
    return;
  }

  if (!menu.classList.contains("nav-menu")) {
    menu.classList.add("nav-menu");
  }

  // Toggle the .toggled class and the aria-expanded value each time the button is clicked.
  button.addEventListener("click", function () {
    siteNavigation.classList.toggle("toggled");

    if (button.getAttribute("aria-expanded") === "true") {
      button.setAttribute("aria-expanded", "false");
    } else {
      button.setAttribute("aria-expanded", "true");
    }
  });

  // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
  document.addEventListener("click", function (event) {
    const isClickInside = siteNavigation.contains(event.target);

    if (!isClickInside) {
      siteNavigation.classList.remove("toggled");
      button.setAttribute("aria-expanded", "false");
      button.classList.remove("activate");
    }
  });

  // Get all the link elements within the menu.
  const links = menu.getElementsByTagName("a");

  // Get all the link elements with children within the menu.
  const linksWithChildren = menu.querySelectorAll(
    ".menu-item-has-children > a, .page_item_has_children > a"
  );

  // Toggle focus each time a menu link is focused or blurred.
  for (const link of links) {
    link.addEventListener("focus", toggleFocus, true);
    link.addEventListener("blur", toggleFocus, true);
  }

  // Toggle focus each time a menu link with children receive a touch event.
  for (const link of linksWithChildren) {
    link.addEventListener("touchstart", toggleFocus, false);
  }

  /**
   * Sets or removes .focus class on an element.
   */
  function toggleFocus() {
    if (event.type === "focus" || event.type === "blur") {
      let self = this;
      // Move up through the ancestors of the current link until we hit .nav-menu.
      while (!self.classList.contains("nav-menu")) {
        // On li elements toggle the class .focus.
        if ("li" === self.tagName.toLowerCase()) {
          self.classList.toggle("focus");
        }
        self = self.parentNode;
      }
    }

    if (event.type === "touchstart") {
      const menuItem = this.parentNode;
      event.preventDefault();
      for (const link of menuItem.parentNode.children) {
        if (menuItem !== link) {
          link.classList.remove("focus");
        }
      }
      menuItem.classList.toggle("focus");
    }
  }

  // toggle button animation
  document.querySelector(".toggle").addEventListener("click", function () {
    this.classList.toggle("activate");
  });
})();

/**
 * Main homepage toggle
 */
jQuery(document).ready(function ($) {
  var isLateralNavAnimating = false;

  // open/close lateral navigation
  $(".cd-nav-trigger").on("click", function (event) {
    event.preventDefault();
    // stop if nav animation is running
    if (!isLateralNavAnimating) {
      if ($(this).parents(".csstransitions").length > 0)
        isLateralNavAnimating = true;

      $(".trigger-class").toggleClass("navigation-is-open"); // Change 'body' to '.trigger-class'
      $(".cd-navigation-wrapper").one(
        "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
        function () {
          // animation is over
          isLateralNavAnimating = false;
        }
      );
    }
  });
});

// Custom YouTube Video Popup with Resume Functionality
jQuery(function ($) {
  // Video resume storage
  const videoPositions = JSON.parse(
    localStorage.getItem("videoPositions") || "{}"
  );
  let currentVideoId = null;
  let player = null;
  let isPlayerReady = false;

  // Create popup HTML structure
  const popupHTML = `
    <div id="video-popup" class="video-popup-overlay" style="display: none;">
      <div class="video-popup-container">
        <button class="video-popup-close" aria-label="Close video">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="video-popup-content">
          <div class="video-wrapper">
            <div id="youtube-player"></div>
          </div>
        </div>
      </div>
    </div>
  `;

  // Add popup to body if it doesn't exist
  if (!$("#video-popup").length) {
    $("body").append(popupHTML);
  }

  // Load YouTube API
  if (!window.YT) {
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  // Function to extract YouTube video ID from URL
  function getYouTubeVideoId(url) {
    if (!url) return null;

    // Handle different YouTube URL formats
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
      /youtube\.com\/v\/([^&\n?#]+)/,
      /youtube\.com\/user\/[^\/]+#p\/[a-z]\/[0-9]+\/([^&\n?#]+)/,
    ];

    for (let pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1] && match[1].length === 11) {
        return match[1];
      }
    }

    return null;
  }

  // Save video position to localStorage
  function saveVideoPosition(videoId, currentTime) {
    if (currentTime > 10) {
      // Only save if watched for more than 10 seconds
      videoPositions[videoId] = currentTime;
      localStorage.setItem("videoPositions", JSON.stringify(videoPositions));
    }
  }

  // Get saved video position
  function getSavedVideoPosition(videoId) {
    return videoPositions[videoId] || 0;
  }

  // Initialize YouTube Player
  function initializePlayer(videoId) {
    const savedTime = getSavedVideoPosition(videoId);

    if (window.YT && window.YT.Player) {
      player = new YT.Player("youtube-player", {
        height: "100%",
        width: "100%",
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          rel: 0,
          modestbranding: 1,
          start: Math.floor(savedTime),
        },
        events: {
          onReady: function (event) {
            isPlayerReady = true;
            $(".video-popup-loading").remove();

            // Show resume message if applicable
            if (savedTime > 10) {
              showResumeMessage(savedTime);
            }
          },
          onStateChange: function (event) {
            // Save position periodically when playing
            if (event.data === YT.PlayerState.PLAYING) {
              savePositionInterval = setInterval(() => {
                if (player && typeof player.getCurrentTime === "function") {
                  const currentTime = player.getCurrentTime();
                  saveVideoPosition(currentVideoId, currentTime);
                }
              }, 5000); // Save every 5 seconds
            } else {
              clearInterval(savePositionInterval);
            }
          },
        },
      });
    } else {
      // Fallback to iframe if API not loaded
      $("#youtube-player").html(`
        <iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&start=${Math.floor(
        savedTime
      )}" 
                frameborder="0" allowfullscreen style="width:100%;height:100%;"></iframe>
      `);
      $(".video-popup-loading").remove();
    }
  }

  // Show resume message
  function showResumeMessage(savedTime) {
    const minutes = Math.floor(savedTime / 60);
    const seconds = Math.floor(savedTime % 60);
    const timeStr =
      minutes > 0
        ? `${minutes}:${seconds.toString().padStart(2, "0")}`
        : `${seconds}s`;

    const resumeMsg = $(`
      <div class="video-resume-message">
        Resuming from ${timeStr}
      </div>
    `);

    $(".video-wrapper").append(resumeMsg);

    setTimeout(() => {
      resumeMsg.fadeOut(300, function () {
        $(this).remove();
      });
    }, 3000);
  }

  let savePositionInterval;

  // Handle podcast link clicks
  $(document).on("click", ".podcast-link", function (e) {
    e.preventDefault();

    const videoUrl = $(this).attr("href");
    const videoId = getYouTubeVideoId(videoUrl);

    if (!videoId) {
      console.error("Invalid YouTube URL:", videoUrl);
      alert("Sorry, this video cannot be played. Invalid YouTube URL.");
      return;
    }

    currentVideoId = videoId;
    const $popup = $("#video-popup");

    // Show popup with loading state
    $popup.show().addClass("show");
    $("body").addClass("popup-open");

    // Add loading indicator
    const $videoWrapper = $(".video-wrapper");
    $videoWrapper.append(
      '<div class="video-popup-loading">Loading video...</div>'
    );

    // Clear previous player
    $("#youtube-player").empty();

    // Initialize player
    initializePlayer(videoId);
  });

  // Close popup functionality
  function closeVideoPopup() {
    const $popup = $("#video-popup");

    // Save current video position before closing
    if (
      player &&
      currentVideoId &&
      typeof player.getCurrentTime === "function"
    ) {
      try {
        const currentTime = player.getCurrentTime();
        saveVideoPosition(currentVideoId, currentTime);
      } catch (e) {
        console.log("Could not save video position:", e);
      }
    }

    // Clear intervals
    clearInterval(savePositionInterval);

    // Remove any loading indicators and messages
    $(".video-popup-loading, .video-resume-message").remove();

    // Hide popup
    $popup.removeClass("show");
    $("body").removeClass("popup-open");

    // Wait for animation to complete before cleanup
    setTimeout(() => {
      $popup.hide();

      // Destroy player
      if (player && typeof player.destroy === "function") {
        try {
          player.destroy();
        } catch (e) {
          console.log("Could not destroy player:", e);
        }
      }

      // Clear player container
      $("#youtube-player").empty();

      // Reset variables
      player = null;
      currentVideoId = null;
      isPlayerReady = false;
    }, 300);
  }

  // Close button click
  $(document).on("click", ".video-popup-close", closeVideoPopup);

  // Close on overlay click
  $(document).on("click", ".video-popup-overlay", function (e) {
    if (e.target === this) {
      closeVideoPopup();
    }
  });

  // Close on escape key
  $(document).on("keydown", function (e) {
    if (e.keyCode === 27 && $("#video-popup").is(":visible")) {
      closeVideoPopup();
    }
  });
});
